import { DateTime } from '@ui/v2/Table/cells/DateTime'
import { VIEW_MORE_ARROW_COL_KEY } from '@ui/v2/Table/hooks/useTableSearch'
import { BaseColumn, BaseColumnCtx } from '@ui/v2/Table/types'

import { formatDate } from '@utils/date.utils'

import { IntroducingBrokerReportDto } from '@model/IntroducingBrokerReportDto'

import { IBReportsTableSortKeys } from './IBReportsReportTable'

export interface ReportColumnCtx extends BaseColumnCtx {
  formatNumber: (v?: number) => string
}
export type ReportColumn = BaseColumn<
  IntroducingBrokerReportDto,
  ReportColumnCtx,
  IBReportsTableSortKeys | typeof VIEW_MORE_ARROW_COL_KEY
>

export const reportColumns: ReportColumn[] = [
  {
    id: 'login',
    labelKey: 'Trading Account.Trading Account',
    responsiveWidth: { desktop: { minWidth: 160 } },
    getValue: ({ login }) => login,
    visibleOnMobile: true,
  },
  {
    id: 'email',
    labelKey: 'Sign up.Email',
    minWidth: 130,
    getValue: ({ email }) => email,
  },
  {
    id: 'clientName',
    labelKey: 'IB.Client Name',
    minWidth: 130,
    getValue: ({ clientName }) => clientName,
  },
  {
    id: 'accountType',
    labelKey: 'IB.Account Type',
    minWidth: 96,
    getValue: ({ accountType }) => accountType,
  },
  {
    id: 'registrationDate',
    labelKey: 'IB.Registration Date',
    minWidth: 130,
    getValue: ({ registrationDate }, { t, dateFormat }) => {
      const [date, time] = formatDate(registrationDate, { formatType: dateFormat })?.split(' ') ?? [
        '',
        '',
      ]
      return <DateTime date={date} time={time} t={t} />
    },
  },
  {
    id: 'status',
    labelKey: 'Status',
    minWidth: 80,
    getValue: ({ status }) => status,
  },
  {
    id: 'balance',
    labelKey: 'Trading Account.Balance',
    minWidth: 130,
    align: 'right',
    isNumeric: true,
    getValue: ({ balance, currency }, { formatMoney }) => formatMoney?.(balance, currency),
  },
  {
    id: 'volumeSince2019',
    labelKey: 'IB.Volume Since 2019',
    align: 'right',
    isNumeric: true,
    getValue: ({ volumeSince2019 }, { formatNumber }) => formatNumber(volumeSince2019),
  },
  {
    id: 'volumeCurrentMonth',
    labelKey: 'IB.Volume Current Month',
    align: 'right',
    isNumeric: true,
    visibleOnMobile: true,
    getValue: ({ volumeCurrentMonth }, { formatNumber }) => formatNumber(volumeCurrentMonth),
  },
  {
    id: 'volumePreviousMonth',
    labelKey: 'IB.Volume Previous Month',
    align: 'right',
    isNumeric: true,
    getValue: ({ volumePreviousMonth }, { formatNumber }) => formatNumber(volumePreviousMonth),
  },
  {
    id: 'swapFree',
    labelKey: 'IB.Swap Free',
    minWidth: 90,
    getValue: ({ swapFree }, { t }) => (swapFree ? t('Yes') : t('No')),
  },
  {
    id: 'clientEntity',
    labelKey: 'IB.Entity',
    minWidth: 90,
    getValue: ({ clientEntity }) => clientEntity,
  },
  {
    id: 'currency',
    labelKey: 'Currency',
    minWidth: 90,
    getValue: ({ currency }) => currency,
  },
  {
    id: 'country',
    labelKey: 'IB.Country',
    getValue: ({ country }) => country,
  },
  {
    id: VIEW_MORE_ARROW_COL_KEY,
    labelKey: '',
    visibleOnMobile: true,
    align: 'center',
    width: 40,
    getValue: () => null,
  },
]
